import { GameInfo, getFormations } from "@/pages/game";
import FormationField from "./FormationField";
import {
    Select,
    SelectItem
} from "@heroui/react";
import { useEffect, useState } from "react";
import { fetchDataAfterRefresh } from "@/components/login/loginStore";
import { PlayerStats } from "@/types";
import { statParamToName } from "@/utils/names";
import {
    PLAYER_STAT_KEYS,
} from "@/utils/stats.tsx";
import { useTranslation } from 'react-i18next';
import { isMobile } from "@/stores/MenuStore";

interface FieldProps {
    formationWidth: number;
    gameInfo: GameInfo;
}

export default function Field(
    { formationWidth, gameInfo }: FieldProps
) {
    const { t } = useTranslation();

    const formations = getFormations(gameInfo?.lineups || [], gameInfo?.home_id || 0, gameInfo?.away_id || 0);

    const [selectedStat, setSelectedStat] = useState<string>('JERSEY_NUMBER');
    const [playerStats, setPlayerStats] = useState<PlayerStats[]>([]);

    useEffect(() => {
        if (gameInfo) {
            fetchDataAfterRefresh(
                ['/api/player_stats_by_fixture_ids?' + 'fixture_ids=' + gameInfo.id, '/not_premium_endpoints/player_stats.json'],
                (data) => {
                    setPlayerStats(data);
                }
            );
        } else {
            setPlayerStats([]);
            setSelectedStat('JERSEY_NUMBER');
        }
    }, [gameInfo]);


    return (
        <>
            {
                formations.homeFormation && formations.awayFormation &&
                <div className={`flex-1 max-w-[840px] bg-content2 shadow-small self-start rounded-xl p-5 overflow-hidden ${!isMobile() && 'min-w-[840px]'}`}>
                    <div className='flex flex-col'>
                        <p className='text-xl font-medium text-default-700'>{t('field.field_1')}</p>
                        <Select label={t('field.field_2')}
                            items={[{ key: 'JERSEY_NUMBER', label: t('field.field_3') }].concat(
                                PLAYER_STAT_KEYS.map((key) => ({ key: key, label: t(statParamToName(key)) }))
                            )}
                            selectedKeys={[selectedStat]}
                            onChange={(e) => { e.target.value && setSelectedStat(e.target.value); }}
                        >
                            {(item) => (
                                <SelectItem key={item.key}>
                                    {item.label}
                                </SelectItem>
                            )}
                        </Select>
                        <div className="overflow-x-auto mt-4">
                            <div className={`flex ${isMobile() ? 'pe-5 w-max' : 'w-full]'}`}>
                                <FormationField size={formationWidth} name={gameInfo?.home_name || ''} formation={formations.homeFormation} players={gameInfo?.lineups?.filter((player) => player.team_id == gameInfo.home_id)} playerStats={playerStats} selectedStat={selectedStat} />
                                <FormationField size={formationWidth} name={gameInfo?.away_name || ''} formation={formations.awayFormation} rightStart={true} players={gameInfo?.lineups?.filter((player) => player.team_id == gameInfo.away_id)} playerStats={playerStats} selectedStat={selectedStat} />
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                !formations.homeFormation && !formations.awayFormation &&
                <div className={`bg-content2 flex flex-col gap-2 self-start shadow-small rounded-xl p-5 min-h-[150px] ${isMobile() ? 'w-full' : 'min-w-sm'}`}>
                    <p className='text-xl font-medium text-default-700'>{t('field.field_1')}</p>
                    <div className='text-sm text-default-500'>
                        {t('field.field_4')}
                    </div>
                </div>
            }
        </>
    )
}